/**
 * BusEvent
 * (c) Les Affranchis - 2009-2021
 *
 * Author - Martin Tremblay - martin@lesaffranchis.ca
 *
 * Goal: A small event helper used in the Vimy - Living Memorial Vivant project
 */

export default class BusEvent extends CustomEvent
{
	static get EVENTS ()
	{
		return {
			//Use for monitoring purpose
			BROADCAST : "Bus.BROADCAST",
			RECEIVE   : "Bus.RECEIVE",

			/**
			 * READY EVENTS
			 */
			//Use before to get the status of the app
			READY     : "Bus.READY",
			READY_2D  : "Bus.READY_2D",
			READY_3D  : "Bus.READY_3D",
			READY_BUS : "Bus.READY_BUS",

			/**  */
			DATA : "Bus.DATA",
			/**  */
			COPYDECK   : "Bus.COPYDECK",
			PLAY_SOUND : "PLAY_SOUND",

			//Events sent by both layer
			CHANGE_THEME : "memorial-theme-set", //@TODO refactoring name if we use the constant everywhere in the project


			/***
			 * 2D LAYER
			 */

			//Events initiated by the 2d layer
			LOAD_PROGRESS_2D         : "LOAD_PROGRESS_2D",
			TESTIMONIAL_CLOSED       : "memorial-modal-closed", //@TODO refactoring name if we use the constant everywhere in the project
			SHARE_TESTIMONIAL_CLOSED : "SHARE_TESTIMONIAL_CLOSED", //@TODO refactoring name if we use the constant everywhere in the project
			BREADCRUMB_VISIBILITY    : "Bus.Breadcrumb_Visibility",

			SHOW_OTHER_THEMES            : "Bus.SHOW_OTHER_THEMES",
			OTHER_THEMES_REQUESTED       : "Bus.Other_Themes_Requested", //@TODO THH, added this event to know "other themes" button has been triggered
			SHARE_TESTIMONIAL            : "Bus.Share_Testimonial",
			ON_SHARE_TESTIMONIAL         : "Bus.ON_SHARE_TESTIMONIAL",
			CLICK_BREADCRUMBS            : "Bus.CLICK_BREADCRUMBS",
			SHARE_TESTIMONIAL_VISIBILITY : "Bus.Share_Testimonial_Visibility",
			LANG                         : "Bus.LANG",
			GET_VISITED_THEMES           : "Bus.GET_VISITED_THEMES",
			FINISH_EXPERIENCE            : "Bus.Finish_Experience",
			SEND_TO_CREDITS              : "Bus.Send_To_Credits",
			CLICK_THEME_PREV_NEXT        : "CLICK_THEME_PREV_NEXT",
			GET_THEME_PREV_NEXT          : "GET_THEME_PREV_NEXT",
			LAUNCH_TUTORIAL              : "LAUNCH_TUTORIAL",
			SHOW_FOG                     : "SHOW_FOG",
			HIDE_FOG                     : "HIDE_FOG",
			ON_SHOW_FOG                  : "ON_SHOW_FOG",
			ON_HIDE_FOG                  : "ON_HIDE_FOG",


			/** INTRO_STEP
			 * details: {
                    progression: boolean,
                    previousStep: number;
                    step: number;
                    totalSteps: number;
                    percent: number;
                }
			 */
			INTRO_STEP : "INTRO_STEP",

			INTRO_BEGIN_FIRST_TIME : "INTRO_BEGIN_FIRST_TIME",

			INTRO_COMPLETE           : "INTRO_COMPLETE",
			TESTIMONIAL_IS_OFFSCREEN : "TESTIMONIAL_IS_OFFSCREEN",

			COOKIE_CONSENT_CHANGED : "Bus.CookieConsentChanged",

			//CAN_SHOW_NEXT_STEP_INTRO: "Vimy.CAN_SHOW_NEXT_STEP_INTRO", //@TODO MT: Par sur, ca me semble lourd comme étape. Le READY devrait etre suffisant

			//Events initiated by the bus for the 2d layer
			TESTIMONIAL_READY_TO_SLIDE_IN   : "TESTIMONIAL_READY_TO_SLIDE_IN",
			OTHER_THEMES_VISIBILITY         : "Bus.Other_Themes_Visibility",
			ON_GET_VISITED_THEMES           : "Bus.ON_GET_VISITED_THEMES",
			ENABLE_DISABLE_PREV_NEXT_BUTTON : "ENABLE_DISABLE_PREV_NEXT_BUTTON",
			GET_STATUES_RECT_BOUNDS         : "GET_STATUES_RECT_BOUNDS",

			TUTORIAL_EVENT : "TUTORIAL_EVENT",
			CLOSE_TUTORIAL : "CLOSE_TUTORIAL",
			RESET_STATE    : "RESET_STATE",


			OUTRO_START_TEXT  : "OUTRO_START_TEXT",
			OUTRO_2D_FINISHED : "OUTRO_2D_FINISHED",
			SHOW_END_CREDITS  : "SHOW_END_CREDITS",

			/**
			 * 3D LAYER
			 */

			//Events initated by the 3d layer
			LOAD_PROGRESS_3D         : "stage-load-progress",//@TODO refactoring name if we use the constant everywhere in the project
			PAPER_OUT_OF_SCREEN      : "PAPER_OUT_OF_SCREEN",
			PAPER_RETURNED_TO_VORTEX : "PAPER_RETURNED_TO_VORTEX",
			NEW_THEMES_SHOWN         : "NEW_THEMES_SHOWN",
			END_VORTEX_SHOWN         : "END_VORTEX_SHOWN", // @TODO: when end vortex is complete, 2D can launch credits.
			CURSOR_HOVER_3D          : "CURSOR_OVER_3D", // Its comes with options {target:"statue"|"vortex"|null}
			CURSOR_CLICK_3D          : "CURSOR_CLICK_3D", // Its comes with options {target:"statue"|"vortex"}
			ON_STATUES_RECT_BOUNDS   : "ON_STATUES_RECT_BOUNDS",
			ON_VORTEX_READY          : "ON_VORTEX_READY",

			//Events initiated by the bus for the 3d layer
			RETURN_PAPER_TO_VORTEX     : "RETURN_PAPER_TO_VORTEX",
			START_CLOUD                : "stage-play",//@TODO refactoring name if we use the constant everywhere in the project
			SHOW_VORTEX                : "SHOW_VORTEX",
			HIDE_VORTEX                : "HIDE_VORTEX",
			ON_INTRO_STEP              : "ON_INTRO_STEP",
			ON_INTRO_COMPLETE          : "ON_INTRO_COMPLETE",
			ON_SHOW_NEW_THEMES         : "ON_SHOW_NEW_THEMES", //MT Pas sur que c'est utilisé
			SHOW_END_VORTEX            : "SHOW_END_VORTEX",
			SHOW_SPECIFIC_THEME        : "SHOW_SPECIFIC_THEME",
			THEMES_SELECTION_DISPLAYED : "THEMES_SELECTION_DISPLAYED",


			/***
			 * ERROR HANDLING
			 */
			I_DUNNO : "WTF_IS_THIS", //UNKNOWN EVENT
		};
	}

	/** @param {any} options */
	constructor ( strType, options = {} )
	{
		if ( typeof options !== "object" )
			options = {};

		super( strType );

		this.options = options;
	}
}

export let TUTORIAL_EVENTS = {
	BREADCRUMBS_THEMES   : 'BREADCRUMBS_THEMES',
	CHOOSE_INITIAL_THEME : 'CHOOSE_INITIAL_THEME',
	CHOOSE_VORTEX        : 'CHOOSE_VORTEX',
	RECORD_TESTIMONIAL   : 'RECORD_TESTIMONIAL',
	DISCOVER_MORE_THEMES : 'DISCOVER_MORE_THEMES',

	// special-er ones
	CLOSE_TUTORIAL : 'CLOSE_TUTORIAL',
	HIGHLIGHT      : 'HIGHLIGHT',
};
